import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { PersistGate } from 'redux-persist/integration/react';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { Provider } from 'react-redux';
import store from '@/stores';
import { ErrorFallback } from '@/features';
import { Suspense, GlobalContext } from '@/features';

type AppProviderProps = {
  children: React.ReactElement;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Suspense>
      <Provider store={store.store}>
        <PersistGate persistor={store.persistor}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <HelmetProvider>
              <BrowserRouter
                basename={process.env.NODE_ENV === 'development' ? '' : '/management/'}
              >
                <QueryParamProvider
                  adapter={ReactRouter6Adapter}
                  options={{
                    searchStringToObject: queryString.parse,
                    objectToSearchString: queryString.stringify,
                  }}
                >
                  <GlobalContext>{children}</GlobalContext>
                </QueryParamProvider>
              </BrowserRouter>
            </HelmetProvider>
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </Suspense>
  );
};
